import { BsFillPlayFill } from 'react-icons/bs';
export default BsFillPlayFill;

//# sourceMappingURL=Play.js.map